export default __webpack_public_path__ + "static/media/Phoenix Contact.1505d0e0.png";